<template>
	<div class="footer">{{$t('main.FilingNumber')}}</div>
</template>
<style>
.footer {
	padding: 5px 16px;
	text-align: center;
	color: rgba(0, 0, 0, .65);
    font-size: 14px;
    background: #f0f2f5;
    position: fixed;
    left: 0px;
    bottom: 0px;
    width: 100%;
    z-index: 1999;
}
</style>
<script>
export default {};
</script>
